export default __webpack_public_path__ + "static/dashboard-f381a1695a298bb0545c13ef8185d39b.svg";